import LoginHistoryPage from './LoginHistoryPage';
export default LoginHistoryPage;